<script setup lang="ts">
import { computed, onMounted, useTemplateRef } from 'vue';
import ApplicationIcon from '@assets/icons/application.svg';
import useJobContext from '@scripts/composables/useJobContext';
import { useJobSearchStore } from '@scripts/stores/jobSearchStore';

const { searchState } = useJobSearchStore();
const [injectContext] = useJobContext();
const { getLabel } = injectContext();

const formContainer = useTemplateRef('formContainer');

const relevantOptions = computed<[key: string, value: string][]>(() => {
    return Object.entries(searchState.tags).filter(
        ([key]) => key !== 'location'
    );
});

const isVisible = computed(() => {
    return relevantOptions.value.length > 0;
});

const searchString = computed(() => {
    return relevantOptions.value
        .map(([key, value]) => getLabel(key, value))
        .join(', ');
});

onMounted(() => {
    if (!formContainer.value) return;

    const form = formContainer.value.querySelector('form');

    if (!form) return;

    const jobTitleField = form.querySelector(
        `input[type="hidden"][name="fields[jobTitle]"]`
    );
    const jobTypeField = form.querySelector(
        `input[type="hidden"][name="fields[jobType]"]`
    );
    const locationTypeField = form.querySelector(
        `input[type="hidden"][name="fields[locationType]"]`
    );

    if (!jobTitleField || !jobTypeField || !locationTypeField) {
        throw new Error('Form is missing required fields');
    }

    form.addEventListener('onBeforeFormieSubmit', (e) => {
        if (searchState.tags?.jobTitle) {
            jobTitleField.setAttribute('value', searchState.tags.jobTitle);
        }

        if (searchState.tags?.type) {
            jobTypeField.setAttribute('value', searchState.tags.type);
        }

        if (searchState.tags?.locationType) {
            locationTypeField.setAttribute(
                'value',
                searchState.tags.locationType
            );
        }
    });
});
</script>

<template>
    <div
        class="md:container-content md:pt-16"
        :class="{
            hidden: !isVisible,
        }"
    >
        <div class="relative">
            <div
                class="bg-primary text-primary-foreground absolute top-0 left-0 rounded-b p-6 md:p-10"
            >
                <ApplicationIcon class="size-10 fill-current md:size-20" />
            </div>

            <div
                class="card-with-border lg:container-content-sm ml-10 pt-6 md:pt-20"
            >
                <div
                    class="border-primary rounded-b border-2 pt-12.5 pr-10 pb-10 pl-10 md:py-12.5 md:pt-25 md:pr-12.5 md:pl-30"
                    ref="formContainer"
                >
                    <h3 class="text-ml font-bold">
                        Es ist noch nicht das Richtige dabei?
                    </h3>

                    <p class="mb-10">
                        Dann abonnieren Sie gerne Ihre Suche nach
                        <b>{{ searchString }}</b>
                        und erhalten Mails bei neuen Stellenangeboten.
                    </p>

                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>
